import React from "react";
import { Flex, HStack, Text } from "@chakra-ui/react";
import type { StackProps } from "@chakra-ui/react";

export type FieldTagTone = "default" | "critical";

export interface FieldTagProps extends StackProps {
  label: string;
  children: React.ReactNode;
  /** "critical" tints the border, fill, and value text red — use when the value represents a problem (past-due, failed, etc.). */
  tone?: FieldTagTone;
}

const TONE_STYLES: Record<FieldTagTone, { bg?: string; borderColor: string; labelColor: string; valueColor: string }> = {
  default: {
    borderColor: "gray.200",
    labelColor: "content.tertiary",
    valueColor: "content.primary",
  },
  critical: {
    bg: "red.50",
    borderColor: "red.200",
    labelColor: "red.500",
    valueColor: "red.600",
  },
};

export function FieldTag({ label, children, tone = "default", ...rest }: FieldTagProps) {
  const styles = TONE_STYLES[tone];
  return (
    <HStack
      spacing="2"
      align="center"
      border="1px solid"
      borderColor={styles.borderColor}
      bg={styles.bg}
      borderRadius="8px"
      px="10px"
      py="6px"
      display="inline-flex"
      {...rest}
    >
      <Flex direction="column" gap="0" align="flex-start">
        <Text fontSize="10px" color={styles.labelColor} fontWeight="500" lineHeight="1.3" textAlign="left">
          {label}
        </Text>
        <Text fontSize="12px" fontWeight="700" color={styles.valueColor} lineHeight="1.3" textAlign="left">
          {children}
        </Text>
      </Flex>
    </HStack>
  );
}
